import { FC, useMemo } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import urls from '@app/routes/urls'
import { FormattedMessage } from 'react-intl'
import useCookieConsent from '@app/customer/CookieConsent/useCookieConsent'
import useCampaignHref from '@app/hooks/useCampaignHref'
import S from './Footer.styles'

const Footer: FC = () => {
  const location = useLocation()

  const isQuiz = useMemo(() => location.pathname.includes('quiz'), [location.pathname])
  const classNames = useMemo(() => (isQuiz ? 'isQuiz' : ''), [isQuiz])

  const cookie = useCookieConsent()

  const { href: termsUrl } = useCampaignHref({ requestPath: urls.terms })
  const { href: privacyUrl } = useCampaignHref({ requestPath: urls.privacy })
  const { href: cookiesUrl } = useCampaignHref({ requestPath: urls.cookies })

  return (
    <S.Footer className={classNames}>
      <S.FooterInner className={classNames}>
        <nav>
          <NavLink to={termsUrl}>
            <FormattedMessage id="static.nav.terms" />
          </NavLink>
          <NavLink to={privacyUrl}>
            <FormattedMessage id="static.nav.privacy" />
          </NavLink>
          <NavLink to={cookiesUrl}>
            <FormattedMessage id="static.nav.cookies" />
          </NavLink>
          <button type="button" aria-label="cookie_preferences" onClick={cookie.openPreferences}>
            <FormattedMessage id="static.nav.cookie_preferences" />
          </button>
        </nav>
      </S.FooterInner>
    </S.Footer>
  )
}

export default Footer
